import { RECEIVED_CART, CART_UPDATED, CART_CLEARED } from "../Constants";
import { USER_LOGGED_OUT } from "../../Account/Constants";

export default function (state = {}, action) {
    switch (action.type) {
    case RECEIVED_CART:
    case CART_UPDATED:
        return action.payload;

    case USER_LOGGED_OUT:
    case CART_CLEARED:
        return {};

    default:
        return state;
    }
}